import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {IHomeSteps} from "../../../store/home/Helper";

const useHowItWorksJsonLd = (steps: IHomeSteps[]) => {
    const {i18n} = useTranslation()

    const content = useMemo(() => (
        {
            "@context": "https://schema.org",
            "@type": "HowTo",
            "name": "How It Works - Genie",
            "description": "Learn how Genie works step by step.",
            "url": window.location.href,
            "steps": steps.map((s) => ({
                "@type": "HowToStep",
                "name": s[`label_${i18n.language}`],
                "text": s[`label__${i18n.language}`]
            }))
        }
    ), [steps, i18n.language])
    return {content}
}

export default useHowItWorksJsonLd